import { parsedPhoneNumberAsString } from "../components/global_components/form_components/ControlledPhoneNumber";

export const formatPhoneNumber = (str: string) => {
  return parsedPhoneNumberAsString(str);
};
